

























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { component } from "vue/types/umd";
import bookCard from "./bookCard.vue";
import folder from "./folder.vue";
import addTab from "./addTab.vue";
import mdui from "mdui";
import Sortable from "sortablejs";

@Component({
  components: {
    bookCard,
    addTab,
    folder,
  },
})
export default class list extends Vue {
  private remove: boolean = false;
  private set: boolean = false;
  private addIcon: string =
    "data:image/svg+xml;base64,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";
  // @ts-ignore
  private markList: any = JSON.parse(localStorage.getItem("markList")); //TODO
  private move: boolean = false; //拖动动画状态,sortable 和vue自带动画有冲突，通过move标签不同情况实现两套列表渲染,默认false 因为create方法会判断true不执行
  private touch: boolean = false; //标记是否被触摸了
  private delete: boolean = false; //是否正在删除
  private mdMove: boolean = false; //手机端打开移动模式
  private noMove: boolean = false; //防止拖动
  private stable: any; //拖动列表

  constructor() {
    super();
    this.getMarkListAll();
    var store = this.$store;
    // 可见性事件，切换到本网页后主动刷新
    document.addEventListener("visibilitychange", function () {
      // 用户离开了当前页面
      if (document.visibilityState === "hidden") {
        //   document.title = '页面不可见';
      }
      // 用户打开或回到页面
      if (document.visibilityState === "visible") {
        // @ts-ignore
        store.commit("getMarkList");
      }
    });
  }

  public setMove() {
    // if (this.mdMove == false) {
    //   this.move = false;
    //   this.touch = true;
    // }
  }

  //手机端强制打开拖动
  public setMdMove() {
    this.mdMove = true;
    this.touch = false;
    this.createMove(2);
  }

  public deleteItem(indexId: number) {
    this.move = false;
    this.delete = true;
    setTimeout(() => {
      let index = this.markList.findIndex(
        (item: any) => item.indexId === indexId
      );
      this.markList.splice(index, 1);
    }, 100);
    setTimeout(() => {
      this.delete = false;
    }, 1000);
    this.createMove(1200);
  }

  // mounted() {//TODO 插卡
  //   this.createMove(100);
  // }

  public createMove(sleep: number) {
    if (
      this.move === true ||
      this.touch === true ||
      this.remove === true ||
      this.delete === true
    ) {
      this.touch = false;
      return;
    }

    setTimeout(() => {
      this.move = true;
    }, sleep);
    setTimeout(() => {
      var el: any = document.getElementById("bookList");
      this.stable = new Sortable(el, {
        animation: 200,
        sort: true,
        onEnd: (evt: any): void => {
          this.setSort(evt.oldIndex, evt.newIndex);
        },
      });
    }, sleep + 30);
  }
  get getMarkList(): number {
    return this.$store.state.getMarkList;
  }

  public setSort(oldIndex: number, newIndex: number) {
    // 打开图标蒙版防止拖动
    this.noMove = true;
    // @ts-ignore
    this.$msgbox("正在提交请不要操作");
    var data = JSON.stringify({
      oldId: this.markList[oldIndex].indexId,
      newId: this.markList[newIndex].indexId,
    });
    // @ts-ignore
    this.$httpService.postData(data, true, "setSort", "application/json").then(
      (result: any) => {
        this.getMarkListAll();
      },
      (error: any) => {
        // 关闭图标蒙版防止拖动
        this.noMove = false;
      }
    );
  }

  activated() {}

  public openRemove() {
    this.remove = true;
    this.move = false; // 切换成删除动画模式
  }

  public closeRemove() {
    this.remove = false;
    this.createMove(2);
  }

  @Watch("getMarkList")
  public getMarkListAll() {
    // TODO 重大bugToken为空能拿到数据
    if (this.$store.state.token) {
      let time = "-";
      if (this.$store.state.time) {
        time = this.$store.state.time;
      }
      
      let data = new FormData()
    data.append('time',time)
      // @ts-ignore
      this.$httpService.postData(data, true, "getMarkListAll", "application/x-www-from-urlencoded").then(
        (result: any) => {
          if (result.result) {
            this.$store.commit("setTime", result.time);
            this.markList = result.result;
            localStorage.setItem("markList", JSON.stringify(result.result));
            if (!this.touch) {
              this.move = false; //强制刷新move 下面这个方法用
              this.createMove(100);
              // 关闭图标蒙版防止拖动
              this.noMove = false;
            }
          }
        },
        (error: any) => {
          // 关闭图标蒙版防止拖动
          this.noMove = false;
        }
      );
    }
  }

  public checkLogin() {
    var tk = this.$store.state.token;
    if (tk == null || tk == "") {
      //TODO
      // @ts-ignore
      this.$msgbox("请先登录");
      // 调用登录dialog
      this.$store.commit("openLogin", 1);
    } else {
      var add = new mdui.Dialog("#add"); //登录弹出框对象
      add.open();
    }
  }
}
